import React, { useContext, useState } from 'react'
import AppConfigContext from '../app_layout/app_config_context'
import * as Constants from '../../helpers/constants'

import RemoveEmailFromCache from './components/remove_email_from_cache'
import UpdateDisposableDomain from './components/update_disposable_domain'
import RadarSettings from './components/radar_setting'
import RemoveSysprop from './components/remove_sysprop_support'
import UpdateSysprop from './components/sysprop_update_support'
import GetGatewayEmailUsers from './components/get_gateway_email_users'
import GlobalBfsSetting from './components/global_bfs_setting'
import UpdateSystemProperties from './components/update_system_properties'

import Layout from './layout'

import '../../static/css/miscellaneous.css'

const MiscellaneousApi = () => {
  const { client } = useContext(AppConfigContext)

  const clientDisplayName = Constants.CLIENTS[client.toUpperCase()].DISPLAY_NAME

  const buttonList =
    Constants.MISCELLANEOUS_API_BUTTON_TO_INCLUDE[client].MISCELLANEOUS_API_BUTTON

  const defaultKey = buttonList[0].key
  const [activeKey, setActiveKey] = useState(defaultKey)


  const miscellaneousSidebar = (key) => {
    switch (key) {
      case 'remove_email_cache':
        return <RemoveEmailFromCache client={client} />
      case 'update_domain':
        return <UpdateDisposableDomain client={client} />
      case 'radar_settings':
        return <RadarSettings client={client} />
      case 'update_sysprop':
        return <UpdateSysprop client={client} />
      case 'remove_sysprop':
        return <RemoveSysprop client={client} />
      case 'get_gateway_email_users':
        return <GetGatewayEmailUsers client={client} />
      case 'global_bfs_setting':
        return <GlobalBfsSetting client={client} />
      case 'update_system_properties':
        return <UpdateSystemProperties client={client} />
      default:
        return null
    }
  }

  return (
    <>
      <h1 className='header'>{clientDisplayName} Miscellaneous</h1>
      <Layout
        buttonList={buttonList}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
        miscellaneousSidebar={miscellaneousSidebar}
      />
    </>
  )
}
export default MiscellaneousApi



